import { styled } from "styled-components";

import { ActionButtonItem, DialogIcon } from "common/components";
import { hardNavigate } from "common/utilities/hardNavigate";
import { useTranslate } from "common/utilities/useTranslate";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";

const StyledIcon = styled(DialogIcon)`
  ${iconStyle}
`;

export const DialogActionButton = () => {
  const translate = useTranslate();

  const handleClick = () =>
    hardNavigate(`${import.meta.env.VITE_TOPLINK_URL}/communities/a0e68000000HKmDAAW/pro-network/overview`);

  return (
    <ActionButtonItem label={translate("app.topic.actions.dialogue")} icon={<StyledIcon />} onClick={handleClick} />
  );
};
